export const SourceIconsFormatterClassNames = {
  singleIcon: 'SourceIconsFormatter__single-icon',
  multiIcons: 'SourceIconsFormatter__multi-icon',
} as const;
